import { LAxios } from "../axios";
import { catchHandler } from "../catch-handler";
import { StorageListInput, StorageListOutput } from "./type";

export const storageList = async (
  data?: StorageListInput,
): Promise<StorageListOutput | string | undefined> => {
  try {
    const params = new URLSearchParams();
    params.append("accountId", data?.accountId || "");
    const queryString = params.toString();
    const response = await LAxios.get(`storage/list?${queryString}`, {
      headers: {
        "x-include-skip": data?.skip,
        "x-include-limit": data?.limit,
      },
    });
    return response.data;
  } catch (error) {
    return catchHandler<StorageListOutput | string | undefined>(
      error,
      data,
      storageList,
      {},
    );
  }
};
